export enum ResultSchemaType {
  Free = 1,
  Selectable = 2
}
